import type { CapitalTransfersConfig, MemberCode } from '@/types/waterfall'
import { MEMBERS } from '@/types/waterfall'
import {
  formatCurrencyField,
  parseDistributionAmount,
} from '@/utils/waterfallCalculator'

export type TransferRow = { date: string; from: MemberCode; to: MemberCode; amount: string }

export function transfersFromConfig(value: unknown): TransferRow[] {
  if (!value || typeof value !== 'object') return []
  const rows: TransferRow[] = []
  for (const [date, transfers] of Object.entries(value as Record<string, unknown>)) {
    if (!Array.isArray(transfers)) continue
    for (const entry of transfers) {
      if (!entry || typeof entry !== 'object') continue
      const { from, to, amount } = entry as {
        from?: string
        to?: string
        amount?: number
      }
      if (!MEMBERS.includes(from as MemberCode) || !MEMBERS.includes(to as MemberCode)) continue
      rows.push({
        date,
        from: from as MemberCode,
        to: to as MemberCode,
        amount: formatCurrencyField(Number(amount)),
      })
    }
  }
  return rows.sort(
    (a, b) =>
      a.date.localeCompare(b.date) ||
      a.from.localeCompare(b.from) ||
      a.to.localeCompare(b.to),
  )
}

export function transfersToConfig(rows: TransferRow[]): CapitalTransfersConfig {
  const out: CapitalTransfersConfig = {}
  for (const row of rows) {
    if (!row.date) continue
    if (row.from === row.to) continue
    const parsed = parseDistributionAmount(row.amount)
    if (parsed == null || parsed <= 0.005) continue
    if (!out[row.date]) out[row.date] = []
    out[row.date]!.push({ from: row.from, to: row.to, amount: parsed })
  }
  return out
}
